module.exports = __webpack_public_path__ + "static/media/foto1.bd6ea3e6.png";